import React from 'react'
import { Button } from '@mui/material'
import './style.css'

const MuiButton = (props) => {
  const { width, variant = 'outlined', ...rest } = props
  return (
    <div style={{ width }}>
      <Button {...rest} variant={variant} style={{ width: '100%', textTransform: 'none' }} />
    </div>
  )
}

export default MuiButton
